var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"title":_vm.$route.name}},[(_vm.tabs === 0)?_c('Form',{staticClass:"pa-3"}):_vm._e(),_c('ModalView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }